import { Link } from "@frontend/lib/link";
import { BrandLogo } from "@frontend/components/brand-logo";
import { StoreBadges } from "@frontend/components/site/store-badges";
import { branding } from "@creators/backend/lib/config";

const LEGAL = [
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
  { label: "Delete account", href: "/delete-account" },
] as const;

/** Branded footer for signed-in workspace pages. */
export function AppFooter() {
  return (
    <footer className="shrink-0 border-t border-line bg-canvas">
      <div className="mx-auto w-full max-w-6xl px-4 py-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <Link href="/overview" className="inline-flex items-center" aria-label={branding.name}>
              <BrandLogo wordmarkAlways />
            </Link>
            <p className="mt-1.5 max-w-sm text-xs leading-relaxed text-ink-muted">
              One link for collab offers. Terms in writing. Payments confirmed by both sides.
            </p>
          </div>

          {/* Store badges are desktop-only: on a phone the visitor is already
              one tap from the app, and the badges crowd a small footer. */}
          <div className="hidden sm:block sm:shrink-0">
            <p className="mb-2 text-[10px] font-semibold tracking-[0.14em] text-ink-subtle uppercase">
              Get the app
            </p>
            <StoreBadges compact />
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2 border-t border-line pt-3 sm:flex-row sm:items-center sm:justify-between">
          <nav
            aria-label="Legal"
            className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-ink-subtle"
          >
            <span>© {new Date().getFullYear()} {branding.name}</span>
            {LEGAL.map((item) => (
              <Link key={item.href} href={item.href} className="transition hover:text-ink">
                {item.label}
              </Link>
            ))}
          </nav>
          <p className="text-xs text-ink-subtle">
            {branding.name} never holds collaboration payments.
          </p>
        </div>
      </div>
    </footer>
  );
}
